import React, { useEffect } from "react";
import styles from "./CountryTooltip.module.scss";
import useCountryTooltip from "./useCountryTooltip";
import CountryTooltipHandler from "./CountryTooltipHandler";

export default function CountryTooltip({ country, position, isHighlighted }) {
  const { stateCountryTooltip, setCountryTooltip } = useCountryTooltip();
  const handlers = CountryTooltipHandler(stateCountryTooltip, setCountryTooltip);

  useEffect(() => {
    if (position) {
      handlers.updatePosition(position);
    }
  }, [position, handlers]);

  if (!country || !position) return null;

  return (
    <div
      className={`${styles.Container} ${isHighlighted ? styles.Highlighted : ""}`}
      style={{
        left: `${position.x}px`,
        top: `${position.y}px`,
      }}
    >
      <p className={styles.CountryName}>{country.name}</p>
      {isHighlighted && (
        <p className={styles.ClickHint}>Click to view members</p>
      )}
    </div>
  );
}
